import { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

// Filter of the problem page (same look as the filter of master data mesin bagian in open-case):
// the main fields in a row, the rest behind the arrow button, and the refresh button to pull the data with the filter.
//   filterValue / setFilterValue: { kendaraan, trailer, keterangan, label_grup, di_tangani }
//   onClickRefresh: pull the data with the filter
const ProblemFilter = ({
  filterValue,
  setFilterValue,
  onClickRefresh,
}) => {
  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);

  const genElText = ({ field, name }) => (
    <div className="col-start-start w-full gap-1">
      <label className="font-bold text-sm text-slate-500">{name}</label>
      <InputText
        className="w-full"
        value={filterValue[field]}
        onChange={(e) =>
          setFilterValue({ ...filterValue, [field]: e.target.value })
        }
        onKeyDown={(e) => e.key === "Enter" && onClickRefresh()}
      />
    </div>
  );

  return (
    <div className="col-start-start w-full gap-2">
      {/* Top Row */}
      <div className="flex flex-col md:flex-row justify-between md:items-end w-full gap-4">
        {/* Filters */}
        <div className="flex flex-col md:flex-row w-full gap-4">
          {genElText({ field: "kendaraan", name: "Kendaraan" })}
          {genElText({ field: "keterangan", name: "Keterangan" })}
          {genElText({ field: "label_grup", name: "Label Grup" })}
        </div>

        {/* Actions */}
        <div className="row-end-center gap-2">
          <Button
            icon={`pi pi-chevron-${showAdvancedFilter ? "up" : "down"}`}
            className="p-button-text p-button-sm"
            onClick={() => setShowAdvancedFilter((v) => !v)}
            tooltip="Advanced Filter"
            tooltipOptions={{ position: "top" }}
          />
          <Button
            icon="pi pi-refresh"
            outlined
            rounded
            onClick={() => onClickRefresh()}
          />
        </div>
      </div>

      {/* Advanced Filter */}
      <div
        className={`w-full overflow-hidden transition-all duration-300 ease-in-out ${
          showAdvancedFilter ? "max-h-[300px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="flex flex-col md:flex-row gap-4 w-full pt-2">
          {genElText({ field: "trailer", name: "Trailer" })}
          {genElText({ field: "di_tangani", name: "Ditangani" })}
        </div>
      </div>
    </div>
  );
};

export default ProblemFilter;
